import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { Button, DialogActions, DialogContent, TextField } from "@mui/material";
import PlusIcon from "./../../Assests/plus-icon.svg";
import SelectDataUpload from "./SelectDataUpload";
import {
  createFolder,
  inputFolderValue,
  inputUploadFolderId,
  displayFolderList,
  displayFolderListSuccess,
  displayFolderListError,
  openErrorDialog,
  scenarioaBack,
} from "./../../Redux/Actions/InputData";
import * as actions from "./../../Redux/Actions/InputData";
import CreateFolder from "./CreateFolder";
import { getRequest } from "../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  // DISPLAY_FOLDER_LIST_BY_USECASE_API,
  DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API,
} from "../../Utils/Config";
// eslint-disable-next-line react-hooks/rules-of-hooks

function InputData(props: any) {
  const dispatch: any = useDispatch();
  const [selectFolder, setSelectFolder] = useState();
  const filteredFoldersList = useSelector(
    (state: any) => state.InputDataReducers.filteredFoldersList
  );
  const [folderOptions, setFolderOptions] = useState(
    filteredFoldersList || [
      { id: "0", folder: "Select", folder_time: "Select" },
    ]
  );
  const [inputFolderName, setInputFolderName] = useState("");
  const [selectFolderTimePeriod, setSelectFolderTimePeriod] = useState("");
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId
  );

  const isCreateFolder = useSelector(
    (state: any) => state.InputDataReducers.isCreateFolder
  );

  const { isFolderSelected, isFolderCreated, folderCreationMessage } =
    useSelector((state: any) => state.InputDataReducers);

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );

  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );

  const userData = useSelector(
    (state: any) => state.InputDataReducers.apiUserData
  );
  console.log(userData, "userData");

  useEffect(() => {
    callFolderFilterApi();
  }, [selectedUsecaseId, selectedCategoryId]);

  const callFolderFilterApi = () => {
    dispatch(displayFolderList());
    const urls = API_BASE_URL + DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    if (selectedUsecaseId && selectedCategoryId) {
      getRequest(
        urls,
        {
          useCase: selectedUsecaseId,
          category: selectedCategoryId,
          createdBy: userData.userId,
        },
        header
      )
        .then((response) => {
          if (response.status === 200 && response.data.success) {
            setFolderOptions(response.data.data);
            dispatch(displayFolderListSuccess(response.data.data));
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(displayFolderListError(error.message));
        });
    }
  };

  const handleOpenCreateFolder = () => {
    dispatch(createFolder());
  };

  const handleChangeSelectFolder = (e: any) => {
    setSelectFolder(e.target.value);
    //setSelectedFolderId(e.target.value.id);
    if (e.target.value.id !== undefined) {
      console.log(e.target.value.id, "folderIDDDDD");
      dispatch(inputUploadFolderId(e.target.value.id));
    }
  };

  const handleInputFolderName = (e: any) => {
    setInputFolderName(e.target.value);
    dispatch(inputFolderValue(e.target.value));
    //dispatch(inputUploadFolderId(e.target.value.id));
  };

  const handleSelectTimePeriod = (e: any) => {
    setSelectFolderTimePeriod(e.target.value);
  };

  const handleCreateNewFolderold = () => {
    const request = {
      containerName: "container1001",
      directoryName: inputFolderName,
      // folder: inputFolderName,
      // time:selectFolderTimePeriod
      // folder_time: new Date().getFullYear() + "-" + new Date().getMonth() + "-" + new Date().getDate(),
      createdBy: userData.userId,
    };
    dispatch(actions.onInitCreateNewFolder(request));
    // dispatch(createdFolder());
  };

  // const selectedCategoryId = useSelector(
  //   (state: any) => state.InputDataReducers.selectedCategoryId
  // );

  const handleCreateNewFolder = () => {
    //  console.log('handleCreateNewFolder selectedCategoryId: ', selectedCategoryId);
    const request = {
      id: 0,
      usecase: selectedUsecaseId,
      category: selectedCategoryId,
      folder: inputFolderName,
      folder_time: 1,
      createdBy: userData.userId,
    };
    if (selectedUsecaseId > 0 && selectedCategoryId > 0) {
      dispatch(actions.onInitCreateNewFolder(request));
    }
    // dispatch(createdFolder());
  };

  const handleGobackInputCreate = () => {
    dispatch(scenarioaBack());
  };
  console.log(selectFolder, "selectFolderselectFolder");
  return (
    <>
      {/* Baseline data and Scenario data page */}
      {(isFolderSelected || isFolderCreated) && (
        <SelectDataUpload
          isOpen={isFolderCreated || isFolderSelected}
          inputFolderName={inputFolderName}
        />
      )}
      {isCreateFolder === true ? (
        <CreateFolder
          handleOpenCreateFolder={handleOpenCreateFolder}
          handleCreateNewFolder={handleCreateNewFolder}
          handleGoBack={handleGobackInputCreate}
          handleInputFolderName={handleInputFolderName}
          inputFolderName={inputFolderName}
          handleSelectTimePeriod={handleSelectTimePeriod}
          selectFolderTimePeriod={selectFolderTimePeriod}
        />
      ) : (
        <>
          <DialogContent>
            <div className="input-data-pop">
              <FormControl fullWidth>
                <label className="select-folder-dropdown">Select Folder*</label>
                <TextField
                  id="select-folder"
                  select
                  required
                  label="Select"
                  variant="outlined"
                  onChange={handleChangeSelectFolder}
                  InputLabelProps={{ shrink: true }}
                  value={selectFolder}
                  defaultValue={selectFolder || ""}
                >
                  {folderOptions?.map((d: any) => (
                    <MenuItem key={d.id} value={d}>
                      {d.folder} - {d.time_period}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>
              <div>
                <h2 className="hr-lines">
                  <span>Or</span>
                </h2>
              </div>
              <div
                className="create-new-folder"
                onClick={handleOpenCreateFolder}
              >
                <img src={PlusIcon} alt="" />
                <h2>Create a new Folder</h2>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <div className="modal-action">
              <Button
                variant="outlined"
                className="cancel"
                onClick={props.handleGoBack}
              >
                Go Back
              </Button>
              <Button
                variant="contained"
                className={
                  selectFolder === "" || selectFolder === undefined
                    ? "disabled-proc-btn"
                    : "Next"
                }
                onClick={(e) => props.handleNextInputData(selectFolder)}
              >
                Next
              </Button>
            </div>
          </DialogActions>
        </>
      )}
    </>
  );
}

export default InputData;
